import { render, staticRenderFns } from "./RegInputRadio.vue?vue&type=template&id=26cc3e8d"
import script from "./RegInputRadio.vue?vue&type=script&lang=js"
export * from "./RegInputRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports